import "core-js/modules/es.array.is-array.js";
import { createSelector } from 'reselect';
var root = function root(store) {
  return store.noteTemplates;
};
var application = function application(store) {
  return store.application;
};
export var isNoteTemplatesLoaded = createSelector(root, function (noteTemplateRoot) {
  return noteTemplateRoot.isLoaded;
});
export var getNoteTemplates = createSelector(root, function (noteTemplateRoot) {
  return noteTemplateRoot.templates;
});
export var noteTemplatesList = createSelector(getNoteTemplates, function (templates) {
  return templates && Array.isArray(templates) ? templates : [];
});
export var noteTemplateCategories = createSelector(root, function (noteTemplateRoot) {
  return noteTemplateRoot.categories;
});
export var noteTemplateVariables = createSelector(root, function (noteTemplateRoot) {
  return noteTemplateRoot.variables;
});
export var noteTemplateFilterVisible = createSelector(root, function (noteTemplateRoot) {
  return noteTemplateRoot.filter_visible;
});
export var noteTemplatesFilterSearch = createSelector(root, function (noteTemplateRoot) {
  return noteTemplateRoot.filter_search;
});
export var noteTemplatesFilterCategories = createSelector(root, function (noteTemplateRoot) {
  return noteTemplateRoot.filter_categories;
});
export var noteTemplatesFilterTags = createSelector(root, function (noteTemplateRoot) {
  return noteTemplateRoot.filter_tags;
});
export var noteTemplatesFilterArchive = createSelector(root, function (noteTemplateRoot) {
  return noteTemplateRoot.filter_archived;
});
export var noteTemplatesFilterForAgents = createSelector(root, function (noteTemplateRoot) {
  return noteTemplateRoot.filter_for_agents;
});
export var noteTemplatesFilterForStudents = createSelector(root, function (noteTemplateRoot) {
  return noteTemplateRoot.filter_for_students;
});
export var noteTemplatesFilterRestricted = createSelector(root, function (noteTemplateRoot) {
  return noteTemplateRoot.filter_restricted;
});

// HACK: setting filter_template_types to contain agent if the user is not internal user
// Otherwise, get the filter_template_types which will be admin by default
export var noteTemplatesFilterTemplateTypes = createSelector(root, application, function (noteTemplateRoot, applicationState) {
  var _applicationState$per, _applicationState$per2, _applicationState$per3, _applicationState$per4;
  if (applicationState !== null && applicationState !== void 0 && applicationState.permissions && 'filter_note_template' in applicationState.permissions && !applicationState.permissions.filter_note_template || applicationState !== null && applicationState !== void 0 && (_applicationState$per = applicationState.permissions) !== null && _applicationState$per !== void 0 && _applicationState$per.filter_note_template && applicationState !== null && applicationState !== void 0 && (_applicationState$per2 = applicationState.permissions) !== null && _applicationState$per2 !== void 0 && _applicationState$per2.create_public_note_from_agent_template && !(applicationState !== null && applicationState !== void 0 && (_applicationState$per3 = applicationState.permissions) !== null && _applicationState$per3 !== void 0 && _applicationState$per3.create_public_note_from_admin_template) && !(applicationState !== null && applicationState !== void 0 && (_applicationState$per4 = applicationState.permissions) !== null && _applicationState$per4 !== void 0 && _applicationState$per4.create_private_note_from_template)) {
    return ['agent'];
  }
  return noteTemplateRoot.filter_template_types;
});
export var noteTemplatesFilterActive = createSelector(root, function (noteTemplateRoot) {
  return noteTemplateRoot.filter_categories.length > 0 || noteTemplateRoot.filter_tags.length > 0 || noteTemplateRoot.filter_for_agents || noteTemplateRoot.filter_for_students || noteTemplateRoot.filter_restricted;
});